import geoJSON from 'utils/geoJSON/geoJSON'

const formatMapSeries = ({ regionsData, selectedRegionId }) => {
  let chartData = regionsData.map(region => {
    let name = region.name
    let code = region.code
    let color = '#FFFFFF'
    let id
    if (region.id === selectedRegionId) {
      color = '#0fa4c4'
      id = selectedRegionId
    }
    return {
      name,
      code,
      color,
      id
    }
  })

  let series = [
    {
      type: 'map',
      index: 1,
      mapData: geoJSON.regionLevel,
      data: chartData,
      joinBy: ['NUTS_ID', 'code']
    },
    {
      type: 'mapline',
      index: 2,
      mapData: geoJSON.countryLevel,
      nullColor: '#333',
      showInLegend: false,
      includeInCSVExport: false,
      name: 'borders',
      lineWidth: 0.75,
      color: '#CCCCCC',
      dataLabels: {
        enabled: false
      },
      states: {
        hover: {
          enabled: false
        }
      }
    }
  ]

  return series
}

const mapChartAdapter = {
  formatMapSeries
}
export default mapChartAdapter



// WEBPACK FOOTER //
// ./src/modules/Charts/Map/LayerHeaderMap/LayerHeaderMapAdapter.js